import {
  FaFacebookSquare,
  FaTwitterSquare,
  FaEnvelopeSquare,
  FaPinterestSquare
} from 'react-icons/fa';

import ReactIconLink from '../../atoms/react-icon-link/react-icon-link';
import * as S from './styles';

export function SocialMediaIcons() {
  return (
    <div className="flex space-x-4 text-header2 text-primaryGray mt-8 cursor-pointer">
      <ReactIconLink ctaLink="#">
        <S.IconContainer hoverText="Facebook">
          <FaFacebookSquare />
        </S.IconContainer>
      </ReactIconLink>
      <ReactIconLink ctaLink="#">
        <S.IconContainer hoverText="Twitter">
          <FaTwitterSquare />
        </S.IconContainer>
      </ReactIconLink>
      <ReactIconLink ctaLink="#">
        <S.IconContainer hoverText="Mail">
          <FaEnvelopeSquare />
        </S.IconContainer>
      </ReactIconLink>
      <ReactIconLink ctaLink="#">
        <S.IconContainer hoverText="Pinterest">
          <FaPinterestSquare />
        </S.IconContainer>
      </ReactIconLink>
    </div>
  );
}

export default SocialMediaIcons;
